import React, { useEffect, useState, useRef } from 'react'
import { Box, Container, Grid, Link as MuiLink } from '@mui/material'
import axios from 'axios'
import { Link } from 'react-router-dom'
import './Events.css'
import Title from '../Title/Title'
import myImage2 from '../../assets/images/news4.jpg'
import myImage3 from '../../assets/images/news5.jpg'
import iconEvent from '../../assets/images/icon_news.png'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const Events: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const imagesBoxRef = useRef<HTMLDivElement>(null)

  type GroupTextItem = {
    id: number
    name: string
    link: string | null
    iconCountry: string | null
    countryEvents: {
      id: number
      eventName: string
      eventDate: string
      linkEvent: string
    }[]
  }

  const [showSecondLayer, setShowSecondLayer] = useState(false)
  const images: string[] = [myImage2, myImage3]
  const [currentIndex, setCurrentIndex] = useState<number>(0)
  // const BASE_URL = 'https://app.dfopsa.online'

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const res = await axios.get(
  //         `${BASE_URL}/api/event?populate[countryes][populate]=*`
  //       )
  //       const explore = res?.data?.data?.countryes || []
  //       const mainName = res?.data?.data?.mainName || ''
  //       setExplore(explore)
  //       setMainName(mainName)
  //     } catch (error) {
  //       console.error('Failed to fetch statistic data:', error)
  //     }
  //   }

  //   fetchData()
  // }, [])

  const handlePlayClick = () => {
    videoRef.current?.play()
    setShowSecondLayer(true)
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % images.length)
    }, 3000)

    return () => clearInterval(intervalId)
  }, [images.length])

  useEffect(() => {
    if (imagesBoxRef.current) {
      gsap.fromTo(
        imagesBoxRef.current.querySelectorAll('.imageSlide'),
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: imagesBoxRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    }
  }, [])

  return (
    <Box sx={{ padding: { xs: '0px 0px 3em', md: '3em 0em' } }} id='events'>
      <Grid sx={{ pb: 7, pt: 10 }}>
        <Title tag='h2'>Events</Title>
      </Grid>
      <Container
        maxWidth={false}
        disableGutters
        sx={{ px: 6, paddingInline: { xs: '0px !important' } }}
      >
        {/* <Grid container spacing={1} className='headerButtonEvents'> */}

        <Box
          sx={{
            display: 'grid',
            gap: { xs: '3rem', md: '2rem' },
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr 1fr',
              lg: 'repeat(4, 1fr)',
            },
          }}
          //className='imagesBox'
          ref={imagesBoxRef}
        >
          <Box className='imageSlide'>
            <img src={images[currentIndex]} alt='Slideshow' />
          </Box>

          <Box className='videoBox'>
            <Box
              className={`firstLayer ${
                showSecondLayer ? 'fade-out' : 'fade-in'
              }`}
              onClick={handlePlayClick}
            >
              <svg
                className='play-btn'
                width='150'
                height='150'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle
                  cx='12'
                  cy='12'
                  r='10'
                  stroke='#fff'
                  strokeWidth='1.5'
                />
                <path
                  d='M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z'
                  stroke='#fff'
                  strokeWidth='1.5'
                />
              </svg>
            </Box>
            <video
              ref={videoRef}
              src={require('../../assets/video/news.mp4')}
              muted
              loop
              controls={false}
            />
          </Box>

          <Box className='imageSlide'>
            <img src={images[currentIndex]} alt='Slideshow' />
          </Box>

          <Box className='imageSlide'>
            <Box className='news-icon' style={{ background: '#F68F57' }}>
              <img
                style={{ borderRadius: '50%' }}
                src={iconEvent}
                alt='News'
                width='40px'
                height='40px'
              />
              <Box
                className='titleT'
                sx={{
                  backgroundColor: '#F68F57',
                  color: '#fff',
                  fontWeight: 600,
                }}
              >
                EVENTS
              </Box>
            </Box>
            <img
              src={require('../../assets/images/news1.png')}
              alt='Static 2'
            />
          </Box>
        </Box>
        {/* </Grid> */}
      </Container>
    </Box>
  )
}

export default Events
